<div>
  <ng-content select="app-ui-toggle-button"></ng-content>
</div>
